;(function ( $ ) {

  $.ruckusDevJs = function()
  {
    // don't go any further if we are on the production site
    if ($url.attr('host') == 'www.ruckuswireless.com') { return; }

    addWindowSize();
  };

  // show window size
  function addWindowSize()
  {
    $('header.universal').after('<div id="windowwidth" style="position:fixed; top:0; left:0; background:white; z-index:1000000; font:12px sans-serif; padding:3px;">' + $window.width() + '</div>');
    $window.on('resize', function() {
      waitForFinalEvent(function()
      {
        $('#windowwidth').text($window.width());
      }, 500, 'widththing');
    });
  }

}( jQuery ));
